/*
 * Define the actions that are relevant for this container
 */
export const SETUP_PAGE = 'page/SETUP_PAGE';
export const RESET_PAGE = 'page/RESET_PAGE';